import { useTranslation } from "features/translations";
import { Paragraph, RenderIf } from "shared/components";
import { useViewMode, VIEW_MODES } from "shared/contexts/ViewMode";

import { ButtonAdd } from "../ButtonAdd";
import { useWidgetContent } from "../Content064.context";
import { CourseInfo } from "../CourseInfo";
import { MobileCoursesList } from "../MobileCoursesList";
import styles from "./GridBlock.module.scss";

export const GridBlock = ({}) => {
  const { mode } = useViewMode();
  const { t } = useTranslation();
  const { selectedCourses, availableMetrics } = useWidgetContent();

  return (
    <>
      <RenderIf viewMode={VIEW_MODES.MOBILE}>
        <MobileCoursesList />
        <ButtonAdd label={t("add_more_course")} className={styles.button} />
      </RenderIf>
      <div className={styles.wrapper}>
        <div
          className={styles.list}
          style={{
            gridTemplate:
              mode === `desktop`
                ? `repeat(${
                    availableMetrics.length + 2
                  }, auto) / 240px repeat(${selectedCourses.length}, 430px)`
                : `repeat(${
                    (availableMetrics.length + 1) * 2
                  }, auto) / repeat(${selectedCourses.length}, 245px)`,
          }}
        >
          <RenderIf viewMode={VIEW_MODES.DESKTOP}>
            <Paragraph className={styles.empty}>{""}</Paragraph>
            {availableMetrics.map(({ title }) => (
              <div className={styles.title} key={title}>
                <Paragraph color="dark" appearance="bold">
                  {t(title)}
                </Paragraph>
              </div>
            ))}
            <Paragraph className={styles.empty}>{""}</Paragraph>
          </RenderIf>

          {selectedCourses.map((slug) => (
            <CourseInfo key={slug} slug={slug} />
          ))}
        </div>
      </div>
    </>
  );
};
